module.exports = __webpack_public_path__ + "img/cloudFaq2.3e86b9d4.png";